import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../../builder';
import { Page } from './Page';

export default createBuilderModule(withChildren(Page), {
  name: 'Page',
  inputs: [
    {
      name: 'day',
      type: 'string',
      regex: {
        pattern: '^\\d{2}\\/\\d{2}\\/\\d{4}$',
        message: 'Must be in format: MM/DD/YYYY',
      },
    },
  ],
});
